module.exports = __webpack_public_path__ + "static/modularity-76ae64adb18d242caa463f1e3e398fe3.png";